import React from "react";
import MediaQuery from "react-responsive";
import { HeaderDesktop } from "./Desktop";
import { HeaderMobile } from "./Mobile";

export function Header() {
    return <React.Fragment>
        {/* Desktop View */}
        <MediaQuery minWidth={991.99}>
            <HeaderDesktop />
        </MediaQuery>

        {/* Mobile View */}
        <MediaQuery maxWidth={991.98}>
            <HeaderMobile />
        </MediaQuery>
    </React.Fragment>
}